import styled from '@emotion/styled';
import * as React from 'react';
import { PHONE_MEDIA } from '../vars';

export interface ComparisonWidgetProps {
  className?: string;
  leftTitle: React.ReactNode;
  rightTitle: React.ReactNode;
  left: React.ReactNode;
  right: React.ReactNode;
}

export const ComparisonWidget: React.FC<ComparisonWidgetProps> = (props) => {
  return (
    <S.Root className={props.className}>
      <S.Column>
        <S.Title>{props.leftTitle}</S.Title>
        <S.Card>{props.left}</S.Card>
      </S.Column>
      <S.Column>
        <S.Title>{props.rightTitle}</S.Title>
        <S.Card>{props.right}</S.Card>
      </S.Column>
    </S.Root>
  );
};

namespace S {
  export const Root = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 18px;
    margin-top: 30px;

    @media (max-width: ${PHONE_MEDIA}px) {
      grid-template-columns: minmax(0, 1fr);
    }
  `;

  export const Column = styled.div`
    min-width: 0;
  `;

  export const Title = styled.div`
    text-align: center;
    font-family: 'Inter Tight Variable', sans-serif;
    font-size: 26px;
    font-weight: 800;
    letter-spacing: 0.03em;
    color: ${(p) => p.theme.text.heading};
    opacity: 0.35;
    margin-bottom: 14px;
  `;

  export const Card = styled.div`
    background: ${(p) => p.theme.text.codeBlockBackground};
    border: 1px solid ${(p) => p.theme.text.codeBlockBorder};
    border-radius: 18px;
    padding: 14px;
    box-shadow: ${(p) => p.theme.text.codeBlockShadow};
    overflow: hidden;

    > * {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    img,
    video,
    iframe {
      width: 100%;
      max-width: 100%;
      display: block;
      border-radius: 14px;
      box-shadow: none;
      transform: none !important;
      max-height: none;
      margin: 0;
    }
  `;
}
